module.exports = __webpack_public_path__ + "golfhom-logo.png?22dce73f3d5f2ec90c4708c5772ee3f1";